import React, { ComponentType } from 'react';
import { ListItem, HStack, Text, Link as ExternalLink } from '@stockx/ui';
import { Link as InternalLink, LinkProps } from '@app/router';
import { IconProps } from '@stockx/icons';

type ItemProps = {
  Icon?: ComponentType<IconProps>;
  label: string;
  to: LinkProps['to'];
  onClick?: React.MouseEventHandler;
  isExternal?: boolean;
};

const getHref = (to: LinkProps['to']) => {
  if (typeof to === 'string') {
    return to;
  }

  return to?.pathname;
};

const MenuItem = ({ Icon, label, to, onClick, isExternal }: ItemProps) => {
  const Link = isExternal ? ExternalLink : InternalLink;
  return (
    <Link
      {...(isExternal ? { href: getHref(to) } : { to })}
      onClick={onClick}
      target={undefined}
      color="neutral.black"
      textDecoration="none"
    >
      <ListItem
        as={HStack}
        px={4}
        py={2}
        _hover={{ bg: 'neutral.200' }}
        spacing={3}
        alignItems="center"
      >
        {Icon && <Icon boxSize={5} />}
        <Text>{label}</Text>
      </ListItem>
    </Link>
  );
};

export default MenuItem;
